import React, { useEffect, useState } from "react"
import { Calculator } from "src/features/calculator/components/Calculator"
import { urlSchema, UrlSchema } from "src/features/calculator/schema"

export function CalculatorContainer() {
  const [queryParams, setQueryParams] = useState<UrlSchema | undefined>(undefined)

  function transformObject(params: URLSearchParams) {
    const paramsObject: { [key: string]: string | number } = {}

    // パラメータをオブジェクトに変換
    params.forEach((value: string, key: string) => {
      paramsObject[key] = value
    })

    const outputObject: { [key: string]: any } = {}

    // オブジェクトの各キーをループ
    for (const key in paramsObject) {
      if (Object.hasOwn(paramsObject, key)) {
        const value = paramsObject[key]
        const keys = key.split(".") // ドット区切りで分割

        // reduceを使ってオブジェクトをネストする
        keys.reduce((acc: { [key: string]: any }, currentKey: string, index: number) => {
          // 最後のキーに値を設定
          if (index === keys.length - 1) {
            acc[currentKey] = value
          } else {
            // 中間のキーが存在しない場合、新たにオブジェクトを作成
            acc[currentKey] = acc[currentKey] || {}
          }
          return acc[currentKey] // 次の階層に進む
        }, outputObject)
      }
    }

    return outputObject
  }

  useEffect(() => {
    // 現在のURLからパラメータを取得
    const params = new URLSearchParams(window.location.search)
    const transformedObject = transformObject(params)
    const result = urlSchema.safeParse(transformedObject)

    if (result.success) {
      setQueryParams(result.data)
    } else {
      // 型ガードを明示的に実装
      const errorResult = result as {
        success: false
        error: { errors: Array<{ path: (string | number)[]; message: string }> }
      }
      console.error("Validation Errors:", errorResult.error.errors)
      const errorMessages = errorResult.error.errors
        .map((error) => {
          return `項目: ${error.path.join(" -> ")}, エラー: ${error.message}`
        })
        .join("\n")

      alert(errorMessages)
    }
  }, [])

  if (queryParams === undefined) {
    return <div>Loading...</div>
  }

  return <Calculator queryParams={queryParams} />
}
